import { useQuery } from "@tanstack/react-query";

import { useAuthenticated } from "@app/common/auth/useAuth";

import { getPulseById } from "../api";

const ONE_HOUR = 60 * 60 * 1000;

const usePulseByIdQuery = ({
  id,
  enabled = true,
}: {
  id?: string;
  enabled?: boolean;
}) => {
  const { user } = useAuthenticated();

  return useQuery({
    queryKey: ["pulseById", id],
    queryFn: () => getPulseById(id!),
    enabled: Boolean(user) && Boolean(id) && enabled,
    refetchOnWindowFocus: false,
    staleTime: ONE_HOUR,
    retry: (count, err) => {
      if (err.message.includes("403")) {
        return false;
      }
      return count < 3;
    },
  });
};

export default usePulseByIdQuery;
